<template>
  <div class="text-right mb-3">
    <b-button variant="danger" @click="handleToggleModal">
      {{ trash.length ? (trash.length > 9 ? "9+" : trash.length) : "Empty" }}
      <i class="fa fa-trash" />
    </b-button>
    <b-modal
      ref="my-modal"
      title="Trash basket"
      modalClass="modal-danger"
      centered
      scrollable
    >
      <div class="d-block">
        <div v-if="trash.length">
          <h3>
            {{ trash.length }}
            {{ trash.length > 1 ? `${entity_type}s are` : `${entity_type} is` }}
            about to be deleted. Do you want to continue?
          </h3>
          <b-container>
            <b-row class="mb-1 px-0" v-for="item in trash" :key="item.id">
              <b-col cols="5" class="px-0">
                {{
                  item.name ||
                  item.first_name ||
                  item.identifier ||
                  item.value ||
                  "Not specified"
                }}
              </b-col>
              <b-col cols="4">
                {{
                  (item.sample_type && item.sample_type.name) ||
                  (item.managed_list && item.managed_list.list) ||
                  "Not specified"
                }}
              </b-col>
              <b-col cols="3" class="px-0 text-right">
                <b-button
                  class="btn btn-success px-1 py-0 text-white"
                  @click="restore(item.id)"
                >
                  {{ "Restore " }}
                  <i class="fa fa-refresh" />
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div v-else class="text-center">Trash basket is empty</div>
      </div>
      <template #modal-footer>
        <b-button
          v-if="trash.length"
          variant="success"
          @click="handleRestoreAll()"
          >Restore All</b-button
        >
        <b-button variant="secondary" @click="handleToggleModal()"
          >Cancel</b-button
        >
        <b-button v-if="trash.length" variant="danger" @click="handleConfirm()"
          >Confirm</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import { mapActions } from "vuex";
import { notificationOptions } from "@/shared/toast-notification-options";
import { trashBasketNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { CrmRepositoryFactory } from '@/repositories/crm/CrmRepositoryFactory';

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "ModalTrashBasket",
  props: {
    entity_type: {
      type: String,
      default: () => "",
    },
    trash: {
      type: Array,
      default: () => [],
    },
    repository_type: {
      type: String,
      default: 'lab',
    },
  },
  data() {
    return {
      repository: this.repository_type === 'crm' ? CrmRepositoryFactory.get(this.entity_type) : LabRepositoryFactory.get(this.entity_type),
    };
  },
  methods: {
    ...mapActions(["RESTORE_FROM_TRASH", "CLEAR_TRASH"]),
    restore(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    handleToggleModal() {
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    handleRestoreAll() {
      this.CLEAR_TRASH(this.entity_type);
      this.handleToggleModal();
    },
    handleConfirm() {
      if (this.trash.length) {
        const delBatchList = this.trash.map((item) => item.id);

        return new Promise((resolve, reject) => {
          this.repository
            .deleteBatch(delBatchList)
            .then((response) => {
              if (response && response.status === 200 && response.data) {
                resolve(response);
              } else {
                reject(response);
              }
            })
            .catch((err) => {
              reject(err);
            });
        })
          .then(() => {
            this.CLEAR_TRASH(this.entity_type);
            this.handleToggleModal();
            this.deleteSuccess();
            this.$emit("onUpdate");
          })
          .catch(() => {
            this.deleteFail();
          });
      } else {
        this.handleToggleModal();
      }
    },
  },
  notifications: trashBasketNotifications,
};
</script>
